/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_PlatformsInputs */

const en_pc_cmp_r_platforms = /** @type {(inputs: Pc_Cmp_R_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const zh_pc_cmp_r_platforms = /** @type {(inputs: Pc_Cmp_R_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Pc_Cmp_R_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_platforms = /** @type {((inputs?: Pc_Cmp_R_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_platforms(inputs)
	return zh_pc_cmp_r_platforms(inputs)
});
export { pc_cmp_r_platforms as "pc.cmp.r.platforms" }